import { axInstBasic } from "../../components/Service/Service";

export const fetchMonths = async () => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getMothList`
    );
    
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchTotalChassis = async (parArn, childArn, selectedMonth) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getChassisCount`,{parArn, childArn, selectedMonth}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchTotalJC = async (parArn, childArn, selectedMonth) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getJCCount`,{parArn, childArn, selectedMonth}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchTatPromiseAchievd = async (parArn, childArn, selectedMonth) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getTatPromiseAchievd`,{parArn, childArn, selectedMonth}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchTatPromiseNOTAchievd = async (parArn, childArn, selectedMonth) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getTatPromiseNotAchievd`,{parArn, childArn, selectedMonth}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchDelayResonCount = async (parArn, childArn, selectedMonth) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getDelayReson`,{parArn, childArn, selectedMonth}
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchConfAdnNcData = async (parArn, childArn, selectedMonth) => {
  
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getCongAdnNcData`,{parArn, childArn, selectedMonth}
    );
    
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchJobCardDelayResonData = async (parArn, childArn, selectedMonth) => {
  // console.log("Selected Month", selectedMonth)
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}getJobCardDelayReson`,{parArn, childArn, selectedMonth}
    );
    
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};